import React, { useRef } from 'react';
import {connect} from "react-redux";
import { Toaster } from 'react-hot-toast'
import {notifyError, notifySuccess} from './ToastMessages'

class DGBSettings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            jwt: this.props.state.jwt,
            vin: this.props.state.current_vin,
            dgbApiUrl: this.props.state.dgbApiUrl,
            qrCodeEditUrl: this.props.state.qrCodeEditUrl,
            qrCodeAddUrl: this.props.state.qrCodeAddUrl,
            qrCodeUrl: this.props.state.qrCodeUrl,
            businessRef: this.props.business.reference,
            textMessage: '',
            businessData: [],
            appUrl: null
        };

        this.fetchBusiness = this.fetchBusiness.bind(this);
        this.saveNewTextMessage = this.saveNewTextMessage.bind(this);
    }

    async fetchBusiness() {
        const { jwt, dgbApiUrl } = this.props.state;
        const businessId = this.props.state.business.reference;

        try {
            const response = await fetch(`${dgbApiUrl}/business/${businessId}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${jwt}`
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();
            this.setState({businessData: data});

            if (data.textMessage !== null) {
                this.setState({
                    textMessage: this.state.businessData?.textMessage
                });
            } else {
                this.setState({
                    textMessage: 'No message set.'
                });
            }

            this.setState({
                appUrl: data.appUrl
            });
        } catch (error) {
            console.error('Error fetching VIN details:', error);
        }
    }

    async saveNewTextMessage() {
        const { jwt, dgbApiUrl } = this.props.state;
        const businessId = this.props.state.business.reference;

        try {
            const response = await fetch(`${dgbApiUrl}/business/${businessId}/text-message`, {
                method: 'PATCH',
                headers: {
                    'Authorization': `Bearer ${jwt}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "textMessage": this.state.textMessage
                })
            });

            if (!response.ok) {
                const errorText = await response.text();
                if (errorText.toLowerCase().includes('invalid token')) {
                    window.location.replace(window.location.origin + '/logout');
                }
                throw new Error('Network response was not ok');
            } else {
                notifySuccess(__('New text message saved successfully'));
            }

        } catch (error) {
            console.error('Error fetching VIN details:', error);
        }
    }

    componentDidMount() {
        this.fetchBusiness();
    }

    render() {
        return (
            <div className="edit-vin w-100 right-side-content">
                <div className="main-section">
                    <div className="w-100 p-2 bg-white border-bottom d-flex align-items-center p-3">
                        <p className='mb-0 w-100'>{__('Digital Glove Box - Settings')}</p>
                    </div>
                </div>

                <div className="w-100 p-2 bg-white p-3 dgb-settings-wrapper">
                    <h4>{__('Digital Glove Box QR Code:')}</h4>
                    <div className="mt-1 mb-3 w-100">
                        <div className='mt-0 d-flex flex-column align-content-start flex-wrap'>
                            {this.state.qrCodeUrl
                                ?
                                <>
                                    <a className='position-relative d-block' href={this.state.qrCodeUrl}
                                       target="_blank">{__('Public - Facing Multi-Link Menu')}</a>
                                    <a className='position-relative d-block' href={this.state.qrCodeEditUrl}
                                       target="_blank">{__('Edit Digital Glove Box QR Code')}</a>
                                    {this.state.appUrl &&
                                        <span className='position-relative d-block'>{__('URL to point NFC')}: <a
                                            href={this.state.appUrl} target="_blank">{this.state.appUrl}</a></span>
                                    }
                                </>
                                :
                                <span>{__('A QR Code has not yet been designated for DBG.')}</span>
                            }

                            <span>{__('Document Storage')}: https://my.digitalglovebox.io/documents-storage</span>
                            <span>{__('Vehicle Information')}: https://my.digitalglovebox.io/vehicle-info</span>
                        </div>
                    </div>


                    <h4 className='mt-3'>{__('Default text message for registration:')}</h4>
                    <div className="mt-1 mb-3 w-100">
                        <div className='mt-0 dgb-settings-content'>
                            {/* Edit */}
                            <div className="input-group col-sm-6 dgb-input">
                                <textarea
                                    placeholder={__('Text Message')}
                                    rows={4}
                                    className="input mr-2 w-100"
                                    value={this.state.textMessage}
                                    onChange={(e) => this.setState({textMessage: e.target.value})}
                                ></textarea>
                            </div>

                            {/* Preview */}
                            <div className="col-sm-6">
                                <p className="text-center mt-1">{__('Preview')}:</p>
                                <div className="full-message-preview preview-text text-primary">
                                    <span
                                        className="review-text-preview">{this.state.textMessage} {this.state.businessData.appUrl}</span>
                                </div>
                            </div>
                        </div>

                        <button
                            className='btn btn-primary mt-3'
                            onClick={this.saveNewTextMessage}
                        >
                            {__('Save Changes')}
                        </button>
                    </div>
                </div>

                {/* Toast */}
                <Toaster
                    position="top-center"
                    toastOptions={{
                        duration: 5000,
                    }}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        state: state,
        business: state.business,
        vin: state.current_vin
    }
}

export default connect(mapStateToProps)(DGBSettings)
